import types from './types';

// Work started for one session must not land in the next
const signedOutTypes = [types.logoutSuccess, types.loginFailure, types.refreshTokenFailure];

export default signedOutTypes;
